<bxi-page
  [title]="title()"
  [supportingTitle]="'product-view.supportingTitle' | translate"
  [breadcrumbOptions]="breadcrumbOptions()"
  class="h-screen w-full"
>
  <bxi-property-overview class="h-full w-full"></bxi-property-overview>
</bxi-page>
